<template>
  <div class="pagination">
    <div class="pagination__amount">
      Страница {{ currentPage }} из {{ lastPage }}
    </div>
    <div class="pagination__nav">
      <button class="pagination__btn" :disabled="isFirstPage" @click.stop="getPage(currentPage - 1)">
        <svg class="arrow-prev-icon" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.023 7.96802L1.99946 8.04702M1.99946 8.04702L7.22547 2.97317M1.99946 8.04702L7.3552 13.5634"
                stroke-width="1.5" />
        </svg>
      </button>
      <ul class="pagination__list">
        <li class="pagination__item">
          <a
              class="pagination__link"
              :class="{'pagination__link--current': currentPage === 1}"
              @click="getPage(1)"
          >
            1
          </a>
        </li>

        <li v-if="currentPage > 4 && lastPage > 5">...</li>

        <li class="pagination__item"
            v-for="page in pagination"
            :key="page"
        >
          <a
              class="pagination__link"
              :class="{'pagination__link--current': currentPage === page}"
              @click="getPage(page)"
          >
            {{ page }}
          </a>
        </li>

        <li v-if="lastPage > 5 && currentPage < lastPage - 2">...</li>

        <li class="pagination__item">
          <a
              class="pagination__link"
              :class="{'pagination__link--current': currentPage === lastPage}"
              @click="getPage(lastPage)"
          >
            {{ lastPage }}
          </a>
        </li>
      </ul>
      <button class="pagination__btn" :disabled="isLastPage" @click.stop="getPage(currentPage + 1)">
        <svg class="arrow-next-icon" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.23486 8.03198L15.2584 7.95298M15.2584 7.95298L10.0323 13.0268M15.2584 7.95298L9.90262 2.43663"
                stroke-width="1.5" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagePagination',
  props: {
    pageList: Object,
    currentPage: Number
  },
  computed: {
    lastPage () {
      return this.pageList.pages.length
    },

    isFirstPage () {
      return this.currentPage === 1
    },

    isLastPage () {
      return this.currentPage === this.lastPage
    },

    pagination () {
      const pages = this.pageList.pages
      if (this.currentPage < 5) return pages.filter(page => page > 1 && page < 5 && page !== this.lastPage)
      if (this.currentPage > this.lastPage - 3) return pages.filter(page => page > this.lastPage - 4 && page !== this.lastPage)
      return pages.filter(page => page >= this.currentPage - 1 && page <= this.currentPage + 1)
    }
  },
  methods: {
    getPage (pageNum) {
      this.$emit('get-page', pageNum)
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 60px;
  user-select: none;
  margin-top: 20px;

  &__amount {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #002033;
  }

  &__nav {
    display: flex;
    gap: 10px;
    flex-flow: row nowrap;
    align-items: center;
  }

  &__list {
    display: flex;
    gap: 7px;
  }

  &__link {
    cursor: pointer;

    &--current {
      color: #0071B2;
    }
  }

  &__btn {
    padding: 0;
    color: #0071B2;
    cursor: pointer;

    .arrow-next-icon, .arrow-prev-icon, .section-icon {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .arrow-next-icon, .arrow-prev-icon {
      width: 17px;
      height: 16px;
      stroke: currentColor;
      flex-shrink: 0;
    }

    &[disabled] {
      color: #002033;
      pointer-events: none;
    }
  }
}
</style>
